import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { RegisterIntegration } from '@assetaccountant/core/models/register-integration';

@Component({
  selector: 'app-sage-connect-modal-wrapper',
  templateUrl: './sage-connect-modal-wrapper.component.html',
  standalone: false,
})
export class SageConnectModalWrapperComponent {
  @Input() registerId: number;
  @Input() entityId?: string;
  @Input() companyId = '';
  @Input() companyName = '';
  @Output() complete = new EventEmitter<RegisterIntegration>();
  @Output() cancel = new EventEmitter();

  constructor(public modal: NgbActiveModal) {}

  onCancel() {
    this.cancel.emit();
  }

  onComplete(registerIntegration: RegisterIntegration) {
    this.complete.emit(registerIntegration);
    this.modal.close();
  }
}
